import {importSPKI, jwtVerify} from 'jose';
import {ErrorModel} from "./api/error/error-model";
import {ErrorCode} from "./api/error/error-code";

export class License {
  public customizabilityOption: boolean;
  public invisibilityOption: boolean;

  private static publicKey: string = `-----BEGIN PUBLIC KEY-----
MFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAE7p2F00dj2AawXZNv44YEpFmmONYg
KvumZzJIONO4OcqvLe0j3yE9WYMAHNJSli8kUlxalIfexjXK7JkqGu0lsQ==
-----END PUBLIC KEY-----`;

  private constructor(customizabilityOption: boolean, invisibilityOption: boolean) {
    this.customizabilityOption = customizabilityOption;
    this.invisibilityOption = invisibilityOption;
  }

  public static async create(token: string, siteKey: string, failureCallback: (ErrorModel) => void): Promise<License | undefined> {
    const decoded = await License.verifyAndDecodeToken(token, failureCallback);
    if (!decoded) {
      failureCallback(new ErrorModel(ErrorCode.LICENSE_INVALID, "License is not valid. Please check the given license."));
      return undefined;
    }
    if (decoded.sub !== 'CaptchaBoxLicense') {
      failureCallback(new ErrorModel(ErrorCode.LICENSE_INVALID, "License is not valid. Please check the given license."));
      return undefined;
    }
    if (decoded.siteKey !== siteKey) {
      failureCallback(new ErrorModel(ErrorCode.LICENSE_INVALID, "The license does not match your Captcha / the given siteKey. Please check the given license."));
      return undefined;
    }
    return new License(
      decoded.features?.boxCustomizability ?? decoded.features?.customizability ?? false,
      decoded.features?.boxInvisibility ?? decoded.features?.invisibility ?? false,
    );
  }

  private static async verifyAndDecodeToken(token: string, failureCallback: (ErrorModel) => void): Promise<any> {
    try {
      const key = await importSPKI(this.publicKey, 'ES256');
      const { payload } = await jwtVerify(token, key, { algorithms: ['ES256'] });
      return payload;
    } catch (err) {
      failureCallback(new ErrorModel(ErrorCode.LICENSE_INVALID, "Failed to check the validity of the license. Please check the given license."));
      return undefined;
    }
  }
}
